/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { Button, Col, Divider, Modal, Row } from 'antd';
import { implementePortfolio } from '../../data/store/account/accountActions';

const ModalImplemente = ({
  openModalImplemente,
  closeModalImplemente,
  executed,
}) => {
  const { t } = useTranslation('');
  const dispatch = useDispatch();

  const { isLoading } = useSelector((state) => state.accountReducer);

  const getCandidate = () => {
    const candidat = executed?.find((i) => i.id === openModalImplemente);
    return candidat;
  };

  const handleImplemente = () => {
    const data = {
      callBack: closeModalImplemente,
      candidatId: openModalImplemente,
      portfolioId: getCandidate()?.portfolio_id
    };
    dispatch(implementePortfolio(data));
  };

  return (
    <Modal
      width={700}
      className="modal-content-paper custom-modal"
      open={openModalImplemente}
      onCancel={closeModalImplemente}
      destroyOnClose={true}
      zIndex={1600}
      footer={null}
    >
      <div>
        <h1 className='modal-header-title'>{t('CONFIRM_EXECUTION')}</h1>
        <Divider className='filter-divider' style={{marginTop: '32px'}}/>
        <Row justify="start" className="modal-text-wrapper">
          <Col>
            <p className="modal-advisor-text modal-question-text">{t('WANT_ORDER_IMPLEMENTE')}</p>
            <p className="modal-advisor-name modal-item-name">{getCandidate()?.name}</p>
          </Col>
        </Row>
      </div>
      <Row justify='end' className="modal-footer-btn-wrapper">
        <Button
          disabled={isLoading}
          className="modal-action-btn cancel-btn"
          onClick={closeModalImplemente}
        >
          {t('CANCEL')}
        </Button>
        <Button
          disabled={isLoading}
          className="modal-action-btn save-btn"
          onClick={handleImplemente}
        >
          {t('EXECUTED')}
        </Button>
      </Row>
    </Modal>
  );
};

export default ModalImplemente;

ModalImplemente.propTypes = {
  executed: PropTypes.array,
  openModalImplemente: PropTypes.number,
  closeModalImplemente: PropTypes.func,
};
